export enum WorkorderColumn {
  None = 'domain.enums.work_order_field_options.none',
  Number = 'domain.enums.work_order_field_options.number',
  Company = 'domain.enums.work_order_field_options.company',
  Estimator = 'domain.enums.work_order_field_options.estimator',
  Customer = 'domain.enums.work_order_field_options.customer',
  Insurer = 'domain.enums.work_order_field_options.insurer',
  Plate = 'domain.enums.work_order_field_options.plate',
  Vehicle = 'domain.enums.work_order_field_options.vehicle',
  Observation = 'domain.enums.work_order_field_options.observation',
  EntryDate = 'domain.enums.work_order_field_options.entry_date',
  AuthorizationDate = 'domain.enums.work_order_field_options.authorization_date',
  CloseDate = 'domain.enums.work_order_field_options.close_date',
  ReturnDate = 'domain.enums.work_order_field_options.return_date',
  Status = 'domain.enums.work_order_field_options.status',
  Type = 'domain.enums.work_order_field_options.type',
  Cost = 'domain.enums.work_order_field_options.cost',
  Localiza = 'domain.enums.work_order_field_options.localiza',
  EstimatedLeaveDate = 'domain.enums.work_order_field_options.estimated_leave_date',
  Commission = 'domain.enums.work_order_field_options.commission',
  Tag = 'domain.enums.work_order_field_options.complement_tag',
  activityStatus = 'domain.enums.work_order_field_options.situation',
  Prisma = 'domain.enums.work_order_field_options.prisma',
  fleet = 'domain.enums.work_order_field_options.fleet',
  PortoBattery = 'domain.enums.work_order_field_options.porto_battery',
  PortoBatteryWarranty = 'domain.enums.work_order_field_options.porto_battery_warranty',
  Chassi = 'domain.enums.work_order_field_options.chassi',
  Motorization = 'domain.enums.work_order_field_options.motorization',
  ComplementOrigin = 'domain.enums.work_order_field_options.complement_origin',
  PortoScheduleDate = 'domain.enums.work_order_field_options.schedule_date',
}

export enum CiliaSubAreaNameEnum {
  AUTO_BODY = 'domain.enums.cilia_sub_area_type.auto_body',
  GLAZING = 'domain.enums.cilia_sub_area_type.glazing',
  TAPESTRY = 'domain.enums.cilia_sub_area_type.tapestry',
  ELECTRICAL = 'domain.enums.cilia_sub_area_type.electrical',
  MECHANICAL = 'domain.enums.cilia_sub_area_type.mechanical',
}

export const CiliaSubAreaNameTranslator: Record<CiliaSubAreaNameEnum, string> =
  {
    [CiliaSubAreaNameEnum.AUTO_BODY]: 'funilaria',
    [CiliaSubAreaNameEnum.GLAZING]: 'vidraçaria',
    [CiliaSubAreaNameEnum.TAPESTRY]: 'tapeçaria',
    [CiliaSubAreaNameEnum.ELECTRICAL]: 'elétrica',
    [CiliaSubAreaNameEnum.MECHANICAL]: 'mecânica',
  };

export interface WorkordersConfigurationProfile {
  column: WorkorderColumn;
  active: boolean;
}

export interface UpdateWorkordersConfigurationProfile {
  configurations: WorkordersConfigurationProfile[];
}

export interface CiliaSubAreas {
  ciliaSubAreaName: CiliaSubAreaNameEnum;
  subAreaId: number;
}

export interface WorkorderConfigurationCompany {
  company: {
    id: number;
    name?: string;
  };
  profitMargin: number;
  isAutomaticStock: boolean;
  minimumStockNotification: boolean;
  maxPartDiscount: number;
  maxServiceDiscount: number;
  isKmRequired: boolean;
  prisma: boolean;
  tankLevel: boolean;
  isInstallmentFree: boolean;
  ciliaToken: string;
  audatexWebToken: string;
  partPaint?: {
    subArea: {
      id: number;
      name?: string;
    };
    costPerHour: number;
  };
  partRecuperation?: {
    subArea: {
      id: number;
      name?: string;
    };
    costPerHour: number;
  };
  partChange?: {
    subArea: {
      id: number;
      name?: string;
    };
    costPerHour: number;
  };
  ciliaSubAreas: CiliaSubAreas[];
  boschChecklist: boolean;
  alwaysGenerateActivityByWorkOrder: boolean;
  isMechanicSheetAutoFill: boolean;
  seeIndicatedBy: boolean;
  shareObservation: boolean;
  portoBatteryDefaultEstimatorId?: number;
  alwaysSendWorkOrdersToMyBcs?: boolean;
  completeActivityByClosingWorkOrder?: boolean;
}

export type WorkorderConfigurationCompanyFormValues = Omit<
  WorkorderConfigurationCompany,
  'isInstallmentFree'
> & {
  isInstallmentFree: 'true' | 'false' | undefined;
};
